const HamburgerButton = ({ setIsOpen, isOpen }) => {
  return (
    <button
      className="hamburger-button d-block d-lg-none trackContent"
      aria-controls="hamburger-nav"
      aria-expanded="false"
      data-ae-blurbtype="button"
      data-ae-form-field="true"
      aria-label="main navigation"
      data-link-info={isOpen ? "hamburger|open menu" : "hamburger|close menu"}
      onClick={() => setIsOpen(prev => !prev)}
    >
      <span className={`hamburger ${isOpen ? 'slider-open' : ''}`}>
        <i className="top"></i>
        <i className="middle"></i>
        <i className="bottom"></i>
      </span>
    </button>
  )
};

export default HamburgerButton;